export const resourcesType = {
  FETCH_RESOURCES_REQUEST: "FETCH_RESOURCES_REQUEST",
  FETCH_RESOURCES_SUCCESS: "FETCH_RESOURCES_SUCCESS",
  FETCH_RESOURCES_FAILURE: "FETCH_RESOURCES_FAILURE",

  RESOURCE_SELECTED: "RESOURCE_SELECTED",

  CLEAN_RESOURCES: "CLEAN_RESOURCES",
};
